import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';

import { ThemeService } from 'rev-portal/branding/Theme.Service';

import { SignalRHubsConnection } from 'rev-shared/push/SignalRHubsConnection';
import { SignalRHubsConnectionToken } from 'rev-shared/push/SignalRHubsConnectionToken';
import { SignalrConnectionStatusComponent } from 'rev-shared/push/SignalRConnectionStatus.Component';
import { StateService } from '@uirouter/angular';
import { HubConnectionState } from '@microsoft/signalr/dist/esm';

@Component({
	selector: 'portal-app',
	template: `
		<vb-portal-styles>
		</vb-portal-styles>
		<vb-theme-styles></vb-theme-styles>
		@if(!ready) {
			<vb-loading-spinner [block]="true" [size]="'large'"></vb-loading-spinner>
		}
		<div ui-view  class="height-full">
		</div>
		<signalr-connection-status>
		</signalr-connection-status>

	`,
	standalone: false
})
export class PortalAppComponent implements OnInit {
	public ready: boolean;

	constructor(
		@Inject(SignalRHubsConnectionToken) public SignalRHubsConnection: SignalRHubsConnection,
		public ThemeService: ThemeService,
		public state: StateService
	) {}

	public ngOnInit(): void {
		this.initializeSignalR();
	}

	private initializeSignalR(): void {
		this.SignalRHubsConnection.start()
			.catch(e => console.error('Error Starting SignalR: ', e));
		this.SignalRHubsConnection.stateChanged$.pipe(first(state => state === HubConnectionState.Connected))
			.subscribe(() => this.ready = true);
	}
}
